import React from 'react';
import styled from 'styled-components';
import { colors } from '../../../styles/variables';

const BGLoading = styled.div`
  width: 100vw;
  height: 100vh;
  backdrop-filter: blur(7px);
  position: fixed;
  z-index: 99999999;

`;

const SectionLoading = styled.div`
  position: absolute;
  top: 35%;
  left: 50%;
  transform: translate(-50%,-50%);
  z-index: 99999999;

  display: grid;
  grid-template-columns: auto auto auto;
  grid-column-gap: 10px;

  div:nth-child(1){
    width: 5px;
    height: 50px;
    background: ${colors.primary.default};
    left: -15px;
    animation-name: line1;
    animation-duration: 4s;
    animation-iteration-count: infinite;
  }
  div:nth-child(2){
    width: 5px;
    height: 50px;
    background: ${colors.primary.default};
    animation-name: line2;
    animation-duration: 4s;
    animation-iteration-count: infinite;
  }
  div:nth-child(3){
    width: 5px;
    height: 50px;
    background: ${colors.primary.default};
    left: 15px;
    animation-name: line3;
    animation-duration: 4s;
    animation-iteration-count: infinite;
  }

  label{
    position: absolute;
    font-family: Arial, Helvetica, sans-serif;
    top: 150%;
    left: -65%;
    font-weight: bold;
    letter-spacing: 2px;
  }

  @keyframes line1 {
    25% { transform: translateY(20px); 
      filter: brightness(200%); }
    50% { transform: translateY(0px);
      filter: brightness(100%); }
    75% { transform: translateY(-20px);
      filter: brightness(200%); }
    100% { transform: translateY(0px);
      filter: brightness(100%); }
  }

  @keyframes line2 {
    25% {
      transform: translateY(-5px);
      filter: brightness(300%);
    }
    50% {
      transform: translateY(0px);
      filter: brightness(100%);
    }
    75% {
      transform: translateY(5px);
      filter: brightness(300%);
    }
    100% {
      transform: translateY(0px);
      filter: brightness(100%);
    }
  }

  @keyframes line3 {
    25% {
      transform: translateY(-20px);
      filter: brightness(100%);
    }
    50% {
      transform: translateY(0px);
      filter: brightness(50%);
    }
    75% {
      transform: translateY(20px);
      filter: brightness(100%);
    }
    100% {
      transform: translateY(0px);
      filter: brightness(50%);
    }
  }

  /* @keyframes label-loading {
    25% { filter: brightness(100%) }
    50% { filter: brightness(200%) }
    75% { filter: brightness(200%) }
    100% { filter: brightness(100%) }
  } */
`;


function Loading(){

  return(
    <BGLoading>
      <SectionLoading>
        <div></div>
        <div></div>
        <div></div>
        <label>LOADING</label>
      </SectionLoading>
    </BGLoading>
  )
}

export default Loading;